// import { useState } from "react";
import "./NewEngineering.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../Images/commission_1.png'
import Footer from "../Component/NewFooter";

const services = [
  {
    id: "valves",
    label: "Valves Asset Management",
    title: "Our commissioning services covers, systematic inspection, testing and validation of mechanical, electrical, instrumentation control, and process systems across upstream, midstream, and downstream facilities.",
    intro:
      "We adopt industry best practices and internationally recognized standards to ensure safe handover, operational readiness, and compliance with HSE, clients' specification and statutory requirements. Through detailed planning, experienced personnel, and disciplined execution, we help clients minimize risks, reduce downtime, and achieve reliable success.",
    intro1:
      "Our commissioning expertise supports onshore and offshore facilities, including production plants, pipelines, terminals, refineries, and gas processing units, delivering seamless transition from construction to stable operations.",
    sections: [
      {
        heading: "Our Services Include:",
        items: [
          "Valve procurement and supply",
          "Valve repair and maintenance",
          "Valve testing and inspection",
          "Valve asset tracking and management",
          "Emergency breakdown support",
          "Valve storage and preservation",
        ],
      },
      {
        heading: "Valve Types Handled:",
        items: [
          "Gate valves, Globe valves, Check valves",
          "Ball valves, Butterfly valves",
          "Safety and relief valves",
          "Control valves and actuators",
        ],
      },
    ],
  },
  {
    id: "octg",
    label: "OCTG Production, Threading & Machine Shop",
    title: "OCTG Production, Threading & Machine Shop Services",
    intro:
      "BOG has an ultra-modern pipe threading plant that threads up to 50,000 metric tons (MT) of pipes per year which will provide an effective seal for pipes transporting liquids, gases, steam, and hydraulic fluid in well operations.",
    sections: [
      {
        heading: "Our Services Include:",
        items: [
          "Tubular Drill pipe Repairs",
          "API 5CT Connection which include: All sizes of EUE, NUE, LTC, STC, and BTC",
          "Manufacturing of Cross overs, Coupling, Blast Joint, pup joint of all length, Flow Coupling, Nipples, etc",
          "Makeup of supplied couplings",
          "Machining of other parts such as lifting plugs, subs etc. as per specification",
          "Repair and re-threading casing and tubing of all sizes",
          "Modification of tubing and casing hanger",
          "Wide range of Certified A.P.I. Gauges for Tubular Equipment Repairs.",
        ],
      },
      {
        heading: "Fabrication Shop Services",
        items: [
          "Fabrication of structures/accessories",
          "Conductor Connector Welding – for Large OD casings",
          "Conductor Accessory Welding – for large O.D. casings",
          "Hardfacing",
          "Inspection Services",
        ],
      },
    ],
  },
  {
    id: "linepipes",
    label: "Line Pipes & Structural Steel",
    title: "Line Pipes and Structural Steel",
    intro:
      "In partnership with internationally recognised and approved mills, BOG supplies line pipes, structural steel and all associated fittings to industry standards for oil and gas operations.",
    sections: [
      {
        heading: "Products Supplied:",
        items: [
          "API 5L line pipes — Grades X42 through X80",
          "Carbon steel and stainless steel pipes",
          "Structural steel sections (H-beams, I-beams, angles)",
          "Flanges, fittings, and valves",
          "Casing and tubing accessories",
        ],
      },
    ],
  },
  {
    id: "hose",
    label: "Hose Assembly & Fabrication",
    title: "Hose Assembly & Fabrication",
    intro:
      "BOG has a fully operational certified hose assembly workshop, manned by trained & certified professionals delivering world-class flexible hose solutions for the oil and gas industry.",
    sections: [
      {
        heading: "Capabilities:",
        items: [
          "High-pressure hydraulic hose assemblies",
          "Offshore & subsea flexible hoses",
          "Custom hose length and end-fitting fabrication",
          "Hose testing and certification",
          "Hose management and tracking",
        ],
      },
    ],
  },
];

 const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction & Camp Setup",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                 href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

// const currentHref = "/Commissioning";

export default function Commissioning() {
  return (
    <>
      <div className="img_carrier">
        <img src={Avatar1} alt="" />
      </div>

      <section className="service-detail">
        <div className="service-detail__layout">

          {/* Left — Content (your existing JSX, unchanged) */}
          <div className="service-detail__content">
            <h2 className="service-detail__title">{services[0].title}</h2>
            <span className="service-detail__divider" />
            <p className="service-detail__intro">{services[0].intro}</p>
            <p className="service-detail__intro">{services[0].intro1}</p>
            {/* {services[0].sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => (
                    <li key={j} className="service-detail__list-item">{item}</li>
                  ))}
                </ul>
              </div>
            ))} */}
          </div>

          {/* Right — Nav links instead of state buttons */}
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink
                key={s.href}
                to={s.href}
                className={({ isActive }) =>
                  `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`
                }
              >
                {s.label}
              </NavLink>
            ))}
          </nav>

        </div>
      </section>
      <Footer />
    </>
  );
}


 